export default __webpack_public_path__ + "static/media/company.b0312245.svg";